const websites = {
  github: "github.com/",
  live: "",
  figma: "figma.com/community/file/",
  cached: ""
};

export default websites;
